module.exports = __webpack_public_path__ + "img/animals_01_H.d6f3e7c7.webp";